import { Box } from "@mui/joy";
import { useEffect, useState } from "react";

import { useProject } from "../../../../hooks/query";
import { MultiProgressBar } from "../../../../shared";

export function StatusGraph() {
    const { useGetProjectStatusSummary } = useProject();
    const projectStatusSvc = useGetProjectStatusSummary();

    const [graphData, setGraphData] = useState<any>([]);

    useEffect(() => {
        if (projectStatusSvc.data) {
            const responseData = projectStatusSvc.data;
            setGraphData([
                { label: "Not Started", count: responseData[statusCode["NOT-STARTED"]] ?? 0, color: "#F44336" },
                { label: "In Progress", count: responseData[statusCode["IN-PROGRESS"]] ?? 0, color: "#1976D2" },
                { label: "Completed", count: responseData[statusCode["COMPLETED"]] ?? 0, color: "#4CAF50" },
                { label: "Cancelled", count: responseData[statusCode["CANCELLED"]] ?? 0, color: "#B0BEC5" },
            ]);
        }
    }, [projectStatusSvc.data]);

    console.log(graphData);

    return (
        <Box>
            <MultiProgressBar statusData={graphData} />
        </Box>
    );
}

const statusCode = {
    "NOT-STARTED": "NOT-STARTED",
    "IN-PROGRESS": "IN-PROGRESS",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED",
};
